module.exports = __webpack_public_path__ + "img/company_3.267a316b.png";